import React, { forwardRef } from 'react'
import { Link } from 'react-router'
import { Box, Button as RebassButton, ButtonProps as RebassButtonProps } from 'rebass/styled-components'
import { LoadingRoundIcon as LoadingIcon } from '../Icon'

export interface ButtonProps extends RebassButtonProps {
  icon?: React.ReactNode
  loading?: boolean
  to?: string
  variant?: string
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ as, children, disabled, hidden, href, icon, loading, to, variant = 'primary', sx, ...props }, ref) => (
    <RebassButton
      as={disabled ? 'button' : as || (href ? 'a' : to ? Link : 'button')}
      disabled={disabled}
      hidden={hidden}
      href={href}
      ref={ref}
      variant={disabled ? `${variant}Disabled` : variant}
      {...(to ? { to } : {})}
      sx={{
        opacity: hidden ? 0 : 1,
        visibility: hidden ? 'hidden' : 'visible',
        ...sx
      }}
      {...props}
    >
      {icon ? (
        <Box as="span" sx={{ lineHeight: 0 }}>
          {icon}
        </Box>
      ) : null}
      {!children || (
        <Box as="span" ml={icon ? '10px' : 0} mr={loading ? '10px' : 0} width={1}>
          {children}
        </Box>
      )}
      {!loading || <LoadingIcon />}
    </RebassButton>
  )
)
Button.displayName = 'Button'

export default Button
